























































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { MasterDataField, NOT_LIVE_REASONS } from "@/data/models/ClientAdministrationRow";
import { CLIENT_SETUP_GROUP_KINDS, ClientSetupMaster } from "@/data/models/ClientSetup";
import { MASTER_DATA_CLIENT_TYPES } from "@/utils/ClientMasterData";
import {
  ClientSetupDraft,
  MIN_PASSWORD_LENGTH,
  defaultClientEmail,
  isEmailAddress,
  setupMasterDataError,
} from "@/utils/ClientSetupDraft";

@Component
export default class SetupMasterDataStep extends Vue {
  @Prop({ required: true }) draft!: ClientSetupDraft;
  @Prop({ default: () => [] }) masters!: ClientSetupMaster[];
  /** While the page still loads the masters in the background: the picker shows its own spinner. */
  @Prop({ type: Boolean, default: false }) mastersLoading!: boolean;
  /** Set by the page when IRES Cloud reported the Kürzel or the address as taken on WEITER. */
  @Prop({ default: false }) prefixTaken!: boolean;
  @Prop({ default: false }) emailTaken!: boolean;

  groupKinds = CLIENT_SETUP_GROUP_KINDS;
  showPassword = false;
  /** A required field is reported once left, not while the step is still being filled in. */
  touched: Record<string, boolean> = {};

  get clientTypeItems() {
    return MASTER_DATA_CLIENT_TYPES.map((value) => ({ value, label: this.$t(`admin.clients.detail.clientTypes.${value}`).toString() }));
  }

  get operationItems() {
    return [
      { value: null, label: this.$t("admin.clients.liveOperation.live").toString() },
      ...NOT_LIVE_REASONS.map((reason) => ({
        value: reason,
        label: this.$t("admin.clients.liveOperation.notLiveWithReason", [this.$t(`admin.clients.liveOperation.reasons.${reason}`)]).toString(),
      })),
    ];
  }

  get masterItems() {
    return this.masters.map((master) => ({ id: master.id, name: master.name }));
  }

  get emailErrors(): string[] {
    if (this.emailTaken) {
      return [this.$t("admin.clients.setup.errors.EMAIL_TAKEN").toString()];
    }
    const typed = this.draft.email.trim() !== "";
    return (typed || this.touched.email) && !isEmailAddress(this.draft.email)
      ? [this.$t("common.invalidEmailAddress").toString()]
      : [];
  }

  get passwordErrors(): string[] {
    const typed = this.draft.password !== "";
    return (typed || this.touched.password) && this.draft.password.length < MIN_PASSWORD_LENGTH
      ? [this.$t("admin.clients.setup.passwordTooShort", [MIN_PASSWORD_LENGTH]).toString()]
      : [];
  }

  errorFor(field: MasterDataField): string[] {
    const typed = this.draft.masterData[field].trim() !== "";
    const error = setupMasterDataError(field, this.draft.masterData[field]);
    // "Required" waits until the field was left; a wrong value shows at once.
    if (error === null || (error === "required" && !this.touched[field] && !typed)) {
      return [];
    }
    return [this.$t(`admin.clients.masterData.fieldErrors.${error}`).toString()];
  }

  touch(field: string) {
    this.$set(this.touched, field, true);
  }

  /** The sign-in address follows the client number until it is typed by hand, as in IRES Admin. */
  onClientNumberInput(value: string) {
    if (!this.draft.emailEdited) {
      this.draft.email = defaultClientEmail(value);
    }
  }
}
